var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4PostOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 17v32h-4V21H18v-4h55zM10 28h52v28h4V24H10v4zm-7 3h56v33H3V31zm48.73 29L38.28 49l-7.18 5.15L23.9 49 10.5 60h41.23zM55 37l-13.35 9.58L55 57.51V37zm-43.88-2l20 14.23L50.92 35h-39.8zM7 57.7l13.53-11.08L7 37v20.7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Post_office.a6ac1068.svg";
export { SvgE4PostOffice as ReactComponent };